module.exports = __webpack_public_path__ + "static/designPatternsIntro-12576c60304d79d98d7b15072029f553.png";